module.exports = __webpack_public_path__ + "6fcaae41fec7dd8c0bb62986372ec906.svg";